import React, { useEffect, useRef } from "react";
import "./CustomCursor.css";

function CustomCursor() {
  const cursorRef = useRef(null);
  const mouseX = useRef(0);
  const mouseY = useRef(0);
  const currentX = useRef(0);
  const currentY = useRef(0);
  const rafId = useRef(null);

  useEffect(() => {
    const handleMouseMove = (e) => {
      mouseX.current = e.clientX;
      mouseY.current = e.clientY;

      // Hover detection
      const hoveredTag = e.target.tagName.toLowerCase();
      const isHoverable =
        hoveredTag === "button" ||
        hoveredTag === "a" ||
        hoveredTag === "input" ||
        hoveredTag === "textarea" ||
        e.target.classList.contains("hover-target"); // Optional: add your own class

      if (cursorRef.current) {
        if (isHoverable) {
          cursorRef.current.classList.add("hovered");
        } else {
          cursorRef.current.classList.remove("hovered");
        }
      }
    };

    const animate = () => {
      currentX.current += (mouseX.current - currentX.current) * 0.1;
      currentY.current += (mouseY.current - currentY.current) * 0.1;

      if (cursorRef.current) {
        cursorRef.current.style.transform = `translate(${currentX.current - 15}px, ${currentY.current - 15}px)`;
      }

      rafId.current = requestAnimationFrame(animate);
    };

    window.addEventListener("mousemove", handleMouseMove);
    animate();

    return () => {
      window.removeEventListener("mousemove", handleMouseMove);
      cancelAnimationFrame(rafId.current);
    };
  }, []);

  return <div className="custom-cursor" ref={cursorRef}></div>;
}

export default CustomCursor;
